// extracted by mini-css-extract-plugin
export var avatarContainer = "_5d-0";
export var gray = "_5d-f";
export var green = "_5d-c";
export var icon = "_5d-9";
export var image = "_5d-1";
export var lg = "_5d-6";
export var md = "_5d-5";
export var presenceDot = "_5d-b";
export var red = "_5d-d";
export var sm = "_5d-4";
export var status = "_5d-a";
export var xl = "_5d-7";
export var xs = "_5d-3";
export var xxl = "_5d-8";
export var xxs = "_5d-2";
export var yellow = "_5d-e";